import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const DISMISS_KEY = "hb_launch_banner_dismissed_at";
const RESHOW_HOURS = 24;

const VARIANTS = {
  royal:  { bg: "#1D4ED8", fg: "#ffffff", border: "#D4A64A" },
  gold:   { bg: "#D4A64A", fg: "#0A1F44", border: "#0A1F44" },
  red:    { bg: "#B91C1C", fg: "#ffffff", border: "#F5D27C" },
};

export default function LaunchBanner() {
  const [banner, setBanner] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.get("/site/banner").then(r => {
      if (cancelled) return;
      const b = r.data;
      if (!b?.enabled) { setBanner(null); setVisible(false); return; }
      setBanner(b);
      // Respect per-browser dismissal for 24h
      try {
        const dismissedAt = Number(localStorage.getItem(DISMISS_KEY) || 0);
        const freshAgain = Date.now() - dismissedAt > RESHOW_HOURS * 3600 * 1000;
        setVisible(freshAgain);
      } catch { setVisible(true); }
    }).catch(() => setBanner(null));
    return () => { cancelled = true; };
  }, []);

  if (!banner || !visible) return null;
  const palette = VARIANTS[banner.variant] || VARIANTS.royal;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch {}
    setVisible(false);
  };

  return (
    <div
      className="relative text-center text-xs sm:text-sm tracking-widest uppercase font-semibold py-2.5 px-10"
      style={{ background: palette.bg, color: palette.fg, borderBottom: `2px solid ${palette.border}` }}
      data-testid="launch-banner"
    >
      <span className="mr-3">{banner.message}</span>
      {banner.cta_href && banner.cta_label && (
        <Link
          to={banner.cta_href}
          className="underline underline-offset-4 font-bold hover:no-underline"
          style={{ color: palette.fg }}
          data-testid="launch-banner-cta"
        >
          {banner.cta_label} →
        </Link>
      )}
      <button
        onClick={dismiss}
        aria-label="Dismiss banner"
        className="absolute right-3 top-1/2 -translate-y-1/2 text-base leading-none opacity-75 hover:opacity-100"
        style={{ color: palette.fg }}
        data-testid="launch-banner-close"
      >
        ×
      </button>
    </div>
  );
}
